import downArrow from "../../assets/images/downArrow.svg";
import achievementlist from "../../constants/achievementlist";
import { Card, CardContent, Fade } from "@mui/material";
const achievementItem = ({ item }) => {
  return (
    <div className="w-full flex flex-col-reverse md:flex-row" key={item.title}>
      <div className="w-0 md:w-1/12 border border-[#4D4D4D] border-l-0"></div>
      <div
        className={`w-full md:w-3/4 border flex flex-col text-${
          item.id % 2 === 1 ? "left" : "right"
        } border-[#4D4D4D] p-8  text-[#F0F2F6]`}
      >
        <div className="text-white text-xl md:text-3xl font-HNlight">
          {item.title}
        </div>
        <div
          className={`text-[#ffffff73] md:text-lg font-HNlight p-1 md:${
            item.id % 2 ? "pr-20" : "pl-20"
          }`}
        >
          {item.desc}
        </div>
        <div
          className={`md:flex ${item.id % 2 ? "flex-row" : "flex-row-reverse"}`}
        >
          <Fade in timeout={600}>
            <Card
              sx={{
                width: { sm: "90vw", md: "18vw" },
                backgroundImage: `url(${require(`../../assets/images/${item.img}`)})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "black",
                boxShadow: "0px 4px 20px rgb(59 124 93 / 50%)",
                margin: 1,
                borderRadius: 10,
                animation: "ease-in",
              }}
            >
              <CardContent
                sx={{ padding: 0, height: 250, width: 50 }}
              ></CardContent>
            </Card>
          </Fade>
        </div>
      </div>
      <div className="w-full md:w-2/6 content-center border border-[#4D4D4D] border-r-0 text-[#4D4D4D] text-5xl">
        {item.year}
      </div>
    </div>
  );
};

const Achievements = () => {
  return (
    <Fade in timeout={1000}>
      <div className="flex flex-col mt-24 text-[#F0F2F6] bg-black">
        <div className="w-full flex flex-row">
          <div className="w-1/12 border border-[#4D4D4D] border-l-0 border-t-0"></div>
          <div className="w-3/4 text-2xl md:text-6xl flex text-left border border-[#4D4D4D] p-2 md:p-14 font-HNthin tracking-wider text-[#F0F2F6] border-t-0">
            <p>
              <strong className="font-HNbold">Awards&nbsp;</strong> & <br></br>
              Recognitions
            </p>
          </div>
          <div className="w-2/6 content-center border border-[#4D4D4D] border-r-0 text-[#4D4D4D] border-t-0">
            {/* <ArrowDownwardOutlined sx={{ fontSize: { sm: 60, md: 120 } }} /> */}
            <img className="mx-auto" src={downArrow} alt="Year" />
          </div>
        </div>
        {achievementlist.map((item) => achievementItem({ item }))}
      </div>
    </Fade>
  );
};
export default Achievements;
